import { Modal } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { SettingsTabType } from '../../../types';

const SETTINGS_TAB_PASSWORD: SettingsTabType = 'Password';

function PasswordExpirationExpiredModal() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNavigate = () => {
    navigate(`/settings?tab=${SETTINGS_TAB_PASSWORD}`);
  };

  return (
    <Modal
      isOpen={true}
      title={t('password_expiration.expired.title')}
      semantic={{
        type: 'warning',
        text: t('common.modal.important'),
      }}
      buttons={[
        {
          children: t('password_expiration.expired.cta'),
          variant: 'accent',
          onClick: handleNavigate,
        },
      ]}
    >
      <p>{t('password_expiration.expired.description')}</p>
    </Modal>
  );
}

export { PasswordExpirationExpiredModal };
